// extracted by mini-css-extract-plugin
export var container = "_mp-0";
export var dotAnimation = "_mp-2";
export var dotsLoading = "_mp-1";